import { useStore } from "@stores";
import { useEffect } from "react";

/** @param enabled `false` preskače učitavanje na ekranima koji spisak gradova ne prikazuju. */
export const useTowns = (enabled = true) => {
  const { townStore } = useStore();
  const { towns, loading, loaded } = townStore;

  useEffect(() => {
    if (enabled) townStore.getAll();
  }, [townStore, enabled]);

  return { towns, loading, loaded };
};
